/**
 * RuleCardHeader — the rule's name, and the one destructive affordance.
 * For Media Devoted | Created By Ciro Autiero
 *
 * Deliberately only these two. Everything that used to crowd this row (scope,
 * match mode, date range, skip, actions) now belongs to the sentence below it,
 * so the name stays the thing you scan a long list by.
 */

import { FC, ReactNode } from 'react';
import { Trash2 } from 'lucide-react';

import { Tooltip } from '@/components/ui';

import { RuleGroupTitle } from '../RuleGroupTitle';

export interface RuleCardHeaderProps {
  name?: string;
  /** 1-based position, for the unnamed rule's "Rule N" fallback. */
  index: number;
  onRename: (name: string | undefined) => void;
  onRemove: () => void;
  /** Beside the trash — the Automation puts the rule's on/off switch here. */
  aside?: ReactNode;
}

export const RuleCardHeader: FC<RuleCardHeaderProps> = ({
  name,
  index,
  onRename,
  onRemove,
  aside,
}) => (
  <div className="-mx-3.5 -mt-3.5 mb-0.5 flex items-center justify-between gap-2 border-b border-border/70 bg-muted/20 px-3.5 py-2">
    <RuleGroupTitle name={name} index={index} onChange={onRename} />
    <span className="ml-auto flex items-center gap-2">
      {aside}
      <Tooltip content="Delete this rule">
        <button
          type="button"
          onClick={onRemove}
          aria-label="Remove group"
          className="flex h-7 w-7 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-destructive/10 hover:text-destructive"
        >
          <Trash2 className="h-4 w-4" aria-hidden />
        </button>
      </Tooltip>
    </span>
  </div>
);

export default RuleCardHeader;
